import { IconInterface } from '../interfaces/icon.interface';

const NewLogoHeader = (props: IconInterface) => {
	const { width = 149, height = 27 } = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 149 27"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M35.9787 17.8498C35.9787 16.9098 36.7336 16.1498 37.6674 16.1498H50.3622C50.5409 16.1498 50.7198 16.1498 50.8986 16.1498C51.1966 16.1498 51.4449 15.8998 51.4548 15.6098C51.4648 15.2998 51.2164 15.0398 50.8986 15.0298C50.7198 15.0298 50.5409 15.0298 50.3622 15.0298H40.9751C37.6375 15.0298 35.9688 13.7898 35.9688 11.3198C35.9688 10.1798 36.3661 9.2598 37.1608 8.5798C37.9554 7.8898 39.2269 7.5498 40.9751 7.5498H53.8388C54.7726 7.5498 55.5275 8.3098 55.5275 9.2498V9.2698C55.5275 10.2098 54.7726 10.9698 53.8388 10.9698H41.1738C40.995 10.9698 40.8162 10.9698 40.6374 10.9698C40.3394 10.9698 40.0911 11.2198 40.0811 11.5098C40.0712 11.8198 40.3196 12.0798 40.6374 12.0898C40.8162 12.0898 40.995 12.0898 41.1738 12.0898H50.5608C53.8984 12.0898 55.5672 13.3298 55.5672 15.7998C55.5672 16.9398 55.1699 17.8498 54.3752 18.5298C53.5806 19.2098 52.3091 19.5498 50.5608 19.5498H37.6773C36.7435 19.5598 35.9787 18.7898 35.9787 17.8498Z"
				fill="#171717"
			/>
			<path
				d="M81.5039 17.8605V9.26055C81.5039 8.32055 82.2588 7.56055 83.1926 7.56055H95.2318C97.129 7.56055 98.5197 7.95055 99.3938 8.72055C100.268 9.49055 100.705 10.5105 100.705 11.7605C100.705 13.0305 100.268 14.0505 99.3938 14.8105C98.5197 15.5705 97.139 15.9605 95.2318 15.9605H86.3812C85.8646 15.9605 85.4474 16.3805 85.4474 16.9005V17.8605C85.4474 18.8005 84.6925 19.5605 83.7588 19.5605H83.2025C82.2688 19.5605 81.5039 18.8005 81.5039 17.8605ZM86.2123 10.9905C85.7852 10.9905 85.4474 11.3405 85.4474 11.7605C85.4474 12.1805 85.7951 12.5305 86.2123 12.5305C89.4208 12.5305 92.6292 12.5305 95.8377 12.5305C96.2648 12.5105 96.6026 12.1605 96.6026 11.7605C96.6026 11.4005 96.3344 11.0705 95.9569 11.0005C92.7087 10.9905 89.4605 10.9905 86.2123 10.9905Z"
				fill="#171717"
			/>
			<path
				d="M119.36 18.8598L118.973 18.3698C118.625 17.9298 118.098 17.6698 117.542 17.6698H108.443C107.887 17.6698 107.361 17.9298 107.013 18.3598L106.616 18.8598C106.268 19.2998 105.741 19.5498 105.185 19.5498H105.056C103.516 19.5498 102.672 17.7598 103.626 16.5498L109.894 8.6698C110.46 7.9598 111.314 7.5498 112.218 7.5498H113.638C114.542 7.5498 115.397 7.95981 115.963 8.67981L122.211 16.5598C123.164 17.7698 122.31 19.5498 120.78 19.5498C120.234 19.5598 119.708 19.2998 119.36 18.8598ZM112.536 11.3898L110.688 13.7198C110.38 14.1098 110.658 14.6898 111.155 14.6898H114.84C115.337 14.6898 115.615 14.1098 115.307 13.7198L113.47 11.3898C113.231 11.0898 112.774 11.0898 112.536 11.3898Z"
				fill="#171717"
			/>
			<path
				d="M130.345 11.6398C129.858 12.0798 129.61 12.7198 129.61 13.5598C129.61 14.3998 129.848 15.0498 130.335 15.4898C130.821 15.9298 131.785 16.1498 133.255 16.1498H142.712C143.645 16.1498 144.4 16.9098 144.4 17.8498C144.4 18.7898 143.645 19.5498 142.712 19.5498H133.255C130.543 19.5498 128.566 18.9998 127.315 17.8998C126.063 16.7998 125.438 15.3498 125.438 13.5498C125.438 11.7498 126.063 10.2998 127.315 9.1998C128.566 8.0998 130.543 7.5498 133.255 7.5498H142.712C143.645 7.5498 144.4 8.3098 144.4 9.2498V9.2698C144.4 10.2098 143.645 10.9698 142.712 10.9698H133.255C131.805 10.9898 130.841 11.1998 130.345 11.6398Z"
				fill="#171717"
			/>
			<path
				d="M76.4386 8.17981C76.2002 7.90981 75.8724 7.6998 75.485 7.6098H75.4751H75.4651C75.4453 7.6098 75.4254 7.5998 75.4055 7.5998C75.3857 7.5998 75.3757 7.5898 75.3559 7.5898C75.336 7.5898 75.3161 7.5798 75.2963 7.5798C75.2863 7.5798 75.2665 7.5798 75.2565 7.5698C75.2367 7.5698 75.2069 7.5698 75.187 7.5598C75.1771 7.5598 75.1572 7.5598 75.1473 7.5598C75.1075 7.5598 75.0678 7.5598 75.038 7.5598C75.0281 7.5598 75.0181 7.5598 75.0082 7.5598C74.9784 7.5598 74.9486 7.5598 74.9188 7.5698C74.8989 7.5698 74.8691 7.5698 74.8493 7.5798C74.442 7.6298 74.0546 7.8098 73.7467 8.0998L69.8329 11.7598C69.4654 12.0998 68.9985 12.2698 68.5317 12.2698C68.0648 12.2698 67.5979 12.1098 67.2304 11.7598L63.3266 8.0898C63.0485 7.8198 62.6909 7.64981 62.3134 7.5798C62.224 7.5598 62.1247 7.5498 62.0353 7.5498C62.0253 7.5498 62.0055 7.5498 61.9955 7.5498H61.9856C61.9657 7.5498 61.9459 7.5498 61.926 7.5498C61.9161 7.5498 61.8962 7.5498 61.8863 7.5498C61.8664 7.5498 61.8366 7.5498 61.8167 7.5598C61.7969 7.5598 61.7869 7.5598 61.777 7.5698C61.7571 7.5698 61.7373 7.5798 61.7174 7.5798C61.6975 7.5798 61.6876 7.5898 61.6677 7.5898C61.6479 7.5898 61.628 7.5998 61.6081 7.5998H61.5982H61.5883C61.2009 7.6898 60.8731 7.8998 60.6347 8.1698C59.989 8.8998 59.9294 10.1198 60.8035 10.8798L65.9291 15.3198C66.3463 15.6798 66.5847 16.1998 66.5847 16.7598V17.6598C66.5847 18.7098 67.4291 19.5498 68.4621 19.5498H68.5416H68.6211C69.6641 19.5498 70.4985 18.6998 70.4985 17.6598V16.7598C70.4985 16.2098 70.7369 15.6798 71.1541 15.3198L76.2797 10.8798C77.1538 10.1298 77.0942 8.90981 76.4386 8.17981Z"
				fill="#171717"
			/>
			<path
				d="M18.3767 27H8.44333C3.77467 27 0 23.19 0 18.5V8.5C0 3.8 3.7846 0 8.44333 0H18.3767C23.0453 0 26.82 3.81 26.82 8.5V18.5C26.82 23.19 23.0354 27 18.3767 27Z"
				fill="url(#paint0_linear_21539_63457)"
			/>
			<path
				d="M10.9375 10.0597C11.0964 9.77969 11.3746 9.61969 11.6924 9.61969L18.5464 9.63969C18.8842 9.63969 19.1524 9.82969 19.3014 10.0797C19.4404 10.3297 19.4702 10.6597 19.3014 10.9597L15.8545 16.9297C15.6956 17.2097 15.4174 17.3697 15.0996 17.3697C14.7718 17.3697 14.5135 17.2097 14.3546 16.9297L12.646 13.9397L10.9375 10.9497C10.7686 10.6497 10.7686 10.3497 10.9375 10.0597ZM20.7715 9.23969C20.553 8.85969 20.2351 8.52969 19.8378 8.28969C19.4603 8.06969 19.0232 7.94969 18.5564 7.94969C16.2717 7.93969 13.987 7.92969 11.7024 7.92969C10.2322 7.92969 9.13957 9.11969 9.12964 10.4997C9.12964 10.7197 9.15944 10.9397 9.20911 11.1497C8.78197 11.2997 8.42437 11.5997 8.18597 12.0097L5.98077 15.8297C5.60331 16.4797 5.65297 17.2097 5.97084 17.7797C6.29864 18.3497 6.90457 18.7597 7.64957 18.7597L12.0401 18.7697C12.5169 18.7697 12.944 18.6197 13.2917 18.3197C13.4506 18.4697 13.6195 18.6097 13.8082 18.7197C14.9903 19.4097 16.5697 19.0597 17.3048 17.7797C18.457 15.7897 19.5994 13.7997 20.7516 11.8197C20.99 11.4097 21.1092 10.9797 21.1092 10.5297C21.1092 10.0597 20.99 9.61969 20.7715 9.23969ZM7.43104 16.9297C7.39131 16.8597 7.38137 16.7697 7.43104 16.6697C8.16611 15.3997 8.90117 14.1397 9.65611 12.8797C9.76537 12.6897 9.95411 12.6397 10.0733 12.8597L11.166 14.7797L12.2586 16.6997C12.3778 16.9097 12.2388 17.0497 12.0302 17.0497C10.57 17.0697 9.11971 17.0697 7.65951 17.0697C7.55024 17.0597 7.47077 16.9997 7.43104 16.9297Z"
				fill="white"
			/>
			<mask
				id="mask0_21539_63457"
				maskUnits="userSpaceOnUse"
				x="8"
				y="6"
				width="8"
				height="8"
			>
				<mask
					id="mask1_21539_63457"
					maskUnits="userSpaceOnUse"
					x="8"
					y="6"
					width="8"
					height="8"
				>
					<path
						d="M11.2434 6.05957L15.8723 8.76957L13.1407 13.4896L8.51172 10.7796L11.2434 6.05957Z"
						fill="url(#paint1_linear_21539_63457)"
					/>
				</mask>
				<g mask="url(#mask1_21539_63457)">
					<path
						d="M11.2434 6.05957L15.8723 8.76957L13.1407 13.4896L8.51172 10.7796L11.2434 6.05957Z"
						fill="url(#paint2_linear_21539_63457)"
					/>
				</g>
			</mask>
			<g mask="url(#mask0_21539_63457)">
				<path
					d="M15.3276 9.63969L14.3542 7.93969L11.6821 7.92969C10.212 7.92969 9.11931 9.11969 9.10938 10.4997C9.10938 10.7197 9.13918 10.9397 9.18884 11.1497C10.0729 10.8397 11.0662 11.1997 11.5331 12.0197L10.9172 10.9397C10.5596 10.3197 11.0265 9.62969 11.6722 9.62969L15.3276 9.63969Z"
					fill="url(#paint3_linear_21539_63457)"
				/>
			</g>
			<mask
				id="mask2_21539_63457"
				maskUnits="userSpaceOnUse"
				x="7"
				y="15"
				width="7"
				height="6"
			>
				<mask
					id="mask3_21539_63457"
					maskUnits="userSpaceOnUse"
					x="7"
					y="15"
					width="7"
					height="6"
				>
					<path
						d="M9.52528 15.0498L13.7767 17.5398L12.0483 20.5398L7.79688 18.0498L9.52528 15.0498Z"
						fill="url(#paint4_linear_21539_63457)"
					/>
				</mask>
				<g mask="url(#mask3_21539_63457)">
					<path
						d="M9.52528 15.0498L13.7767 17.5398L12.0483 20.5398L7.79688 18.0498L9.52528 15.0498Z"
						fill="url(#paint5_linear_21539_63457)"
					/>
				</g>
			</mask>
			<g mask="url(#mask2_21539_63457)">
				<path
					d="M12.8741 17.7695L12.2583 16.6895C12.3775 16.8995 12.2384 17.0395 12.0298 17.0395C10.8179 17.0495 9.616 17.0595 8.41406 17.0595L9.09946 18.7595L12.0397 18.7695C12.5165 18.7695 12.9437 18.6195 13.2913 18.3195C13.1324 18.1595 12.9933 17.9795 12.8741 17.7695Z"
					fill="url(#paint6_linear_21539_63457)"
				/>
			</g>
			<path
				d="M145.645 0.34818C145.591 0.34818 145.547 0.391957 145.547 0.445958V1.50222C145.547 1.55622 145.504 1.6 145.449 1.6H145.211C145.157 1.6 145.113 1.55622 145.113 1.50222V0.445958C145.113 0.391957 145.069 0.34818 145.015 0.34818H144.528C144.474 0.34818 144.43 0.304404 144.43 0.250403V0.0977778C144.43 0.0437766 144.474 0 144.528 0H146.134C146.188 0 146.232 0.0437766 146.232 0.0977778V0.250403C146.232 0.304404 146.188 0.34818 146.134 0.34818H145.645Z"
				fill="#171717"
			/>
			<path
				d="M148.665 1.6C148.611 1.6 148.567 1.55622 148.567 1.50222V0.869129C148.567 0.767229 148.43 0.733285 148.382 0.823296L147.997 1.54805C147.98 1.58002 147.946 1.6 147.91 1.6H147.611C147.575 1.6 147.541 1.58002 147.524 1.54805L147.139 0.823296C147.091 0.733285 146.955 0.767229 146.955 0.869129V1.50222C146.955 1.55622 146.911 1.6 146.857 1.6H146.618C146.564 1.6 146.52 1.55622 146.52 1.50222V0.0977777C146.52 0.0437766 146.564 0 146.618 0H147.052C147.088 0 147.121 0.0198282 147.138 0.0515973L147.674 1.05022C147.711 1.11901 147.81 1.11901 147.847 1.05022L148.383 0.0515972C148.4 0.0198281 148.433 0 148.47 0H148.901C148.955 0 148.999 0.0437766 148.999 0.0977778V1.50222C148.999 1.55622 148.955 1.6 148.901 1.6H148.665Z"
				fill="#171717"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_21539_63457"
					x1="0"
					y1="13.5"
					x2="26.82"
					y2="13.5"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.0220187" stopColor="#494C83" />
					<stop offset="1" stopColor="#7693F4" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_21539_63457"
					x1="7.89341"
					y1="12.2598"
					x2="13.266"
					y2="9.20159"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_21539_63457"
					x1="7.89341"
					y1="12.2598"
					x2="13.266"
					y2="9.20159"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_21539_63457"
					x1="9.20197"
					y1="11.1542"
					x2="14.5172"
					y2="8.19188"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopOpacity="0.5" />
					<stop offset="1" stopColor="#363976" stopOpacity="0" />
				</linearGradient>
				<linearGradient
					id="paint4_linear_21539_63457"
					x1="12.796"
					y1="16.6389"
					x2="9.96093"
					y2="18.2524"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" />
				</linearGradient>
				<linearGradient
					id="paint5_linear_21539_63457"
					x1="12.796"
					y1="16.6389"
					x2="9.96093"
					y2="18.2524"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint6_linear_21539_63457"
					x1="12.4518"
					y1="17.2662"
					x2="8.75322"
					y2="18.4349"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopOpacity="0.5" />
					<stop offset="1" stopColor="#363976" stopOpacity="0" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default NewLogoHeader;
